export const formatLangCoin = ({ value }) => {
    let integral = value.slice(0, -18) || "0";
    let fraction = value.slice(-18, -16) || "00";
    return `${integral}.${fraction}`;
};
